const highContrastProp = {
    type: 'boolean',
    default: undefined,
};
export { highContrastProp };
//# sourceMappingURL=high-contrast.prop.js.map